export const defaultItalyCoordinates = [6.732523653900415, 45.08482580193663] as [number, number]; // italy coordinates [lon, lat]

export const italyBoundingBox = {
  north: 47.092,
  south: 35.493,
  east: 18.52,
  west: 6.626,
} as const;
export const defaultItalyAddressMetaData = {
  address: 'Whole Italia',
  address_lon: defaultItalyCoordinates[0],
  address_lat: defaultItalyCoordinates[1],
  administrative_area_level_1: 'Italia',
  administrative_area_level_2: 'Italia',
  country: 'Italia',
  locality: 'Italia',
  postal_code: '',
};
